// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ManagerInfo-module--wrapper--K8NLj","phoneCol":"ManagerInfo-module--phoneCol--3PkVX"};